"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomAttributeDebouncedNumberInput = exports.CustomAttributeDebouncedTextInput = void 0;
const ui_1 = require("@app/component/ui");
const util_1 = require("@app/util");
const use_debounce_1 = require("@app/util/forms/use-debounce");
const react_1 = __importDefault(require("react"));
const CustomAttributeDebouncedTextInput = ({ name, field, update }) => {
    const { value, onChange } = (0, use_debounce_1.useDebounce)({
        value: field.value,
        onChange: update,
        ms: 750,
    });
    return (react_1.default.createElement(ui_1.Input, { size: 'full-width', type: 'text', label: name, value: value, onChange: onChange }));
};
exports.CustomAttributeDebouncedTextInput = CustomAttributeDebouncedTextInput;
const CustomAttributeDebouncedNumberInput = ({ name, field, update }) => {
    const { value, onChange } = (0, use_debounce_1.useDebounce)({
        value: field.value,
        onChange: update,
        ms: 750,
    });
    return (react_1.default.createElement(ui_1.Input, { size: 'full-width', type: 'number', label: name, value: value ?? undefined, onChange: (v) => onChange(Number.isNaN(parseInt(v)) ? null : parseInt(v)), hasError: (0, util_1.isNull)(value), errorMessage: (0, util_1.isNull)(value)
            ? ((0, util_1.t)('FORM_ERR_MISSING_REQUIRED') ?? 'FORM_ERR_MISSING_REQUIRED')
            : undefined }));
};
exports.CustomAttributeDebouncedNumberInput = CustomAttributeDebouncedNumberInput;
